import xhr from './xhr.js';
import fetch from './fetch.js';

export default function api() { 
  xhr();
  fetch();
}
